import React from 'react';
import './About.css';
import grupoLogo from '../../assets/images/grupo-metropolitana-logo.png'; // Coloque o logo do grupo aqui
import { FaAward } from 'react-icons/fa';

const About = () => {
  return (
    <section className="about-section">
      <div className="container about-container">
        <div className="about-image">
          <img src={grupoLogo} alt="Grupo Metropolitana" />
        </div>
        <div className="about-content">
          <h2 className="section-title-left">Tradição e Confiança que Vêm de Berço</h2>
          <p>
            A Baterias Metropolitana orgulhosamente faz parte do <strong>Grupo Metropolitana</strong>, um nome com anos de tradição e respeito no mercado automotivo. Essa parceria garante a você um serviço com a máxima qualidade e a segurança de quem entende do assunto.
          </p>
          <div className="specialist-highlight">
            <FaAward className="highlight-icon" />
            <div>
              <h3>Serviço Especializado com Apoio de Scanner</h3>
              <p>Seu carro caiu a tensão a quase zero e diversos módulos foram reiniciados? Só trocar a bateria não resolve! Temos a tecnologia e o conhecimento para um diagnóstico preciso e uma troca segura, preservando a eletrônica do seu veículo.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;